import { render, staticRenderFns } from "./bitdialog.vue?vue&type=template&id=43d6caf2&scoped=true"
import script from "./bitdialog.vue?vue&type=script&lang=js"
export * from "./bitdialog.vue?vue&type=script&lang=js"
import style0 from "./bitdialog.vue?vue&type=style&index=0&id=43d6caf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d6caf2",
  null
  
)

export default component.exports